module.exports = __webpack_public_path__ + "static/media/应用场景2_03.bae58107.png";